import type { CompanyArtistContactType } from '@api';
import { TouringCardTable, TouringCardTableBody } from '@common';
import { CompanyArtistsTableRow } from './components';

type CompanyArtistsTablePropsType = {
  contacts: CompanyArtistContactType[];
};

export const CompanyArtistsTable: React.FC<CompanyArtistsTablePropsType> = ({
  contacts,
}) => {
  return (
    <TouringCardTable>
      <TouringCardTableBody>
        {contacts.map((row, index) => (
          <CompanyArtistsTableRow
            key={`${row.category}-${row.person.id}-${String(index)}`}
            row={row}
          />
        ))}
      </TouringCardTableBody>
    </TouringCardTable>
  );
};
